<div class="container themed-dialog">
  <div class="header">
    <div class="header_logo">
      <img [src]="themeService.logoExpandedUrl" />
    </div>
  </div>

  <div class="content">
    <div class="content_left">
      <img [src]="themeService.sideLeftUrl" />
    </div>

    <div class="content_center content-page1">
      <img [src]="themeService.imageCenterUrl" />
      <h2 class="txt-red">{{ 'welcome.title' | translate }}</h2>
      <p>{{ 'welcome.text' | translate }}</p>
      <button mat-flat-button class="accent transparent" (click)="close(true)">
        {{ 'welcome.button' | translate }}
      </button>
    </div>

    <div class="content_right">
      <img [src]="themeService.sideRightUrl" />
    </div>
  </div>
</div>
